<script lang="ts">
  export let visible = false
</script>

{#if visible}
  <div class="skeleton"></div>
{/if}

<style lang="scss">
  .skeleton {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    animation: pulse-animation 1.5s ease-in-out 0.5s infinite;
    background-color: rgba(var(--color-on-surface-rgb), 0.11);
    border-radius: inherit;
  }

  @keyframes pulse-animation {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.4;
    }

    100% {
      opacity: 1;
    }
  }
</style>
